import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrashOutlined = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 15,
	height: 15,
	viewBox: "0 0 15 15",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M4.68701 2.69434H4.56201C4.63076 2.69434 4.68701 2.63809 4.68701 2.56934V2.69434H9.43701V2.56934C9.43701 2.63809 9.49326 2.69434 9.56201 2.69434H9.43701V3.81934H10.562V2.56934C10.562 2.01777 10.1136 1.56934 9.56201 1.56934H4.56201C4.01045 1.56934 3.56201 2.01777 3.56201 2.56934V3.81934H4.68701V2.69434ZM12.562 3.81934H1.56201C1.28545 3.81934 1.06201 4.04277 1.06201 4.31934V4.81934C1.06201 4.88809 1.11826 4.94434 1.18701 4.94434H2.13076L2.5167 13.1162C2.5417 13.649 2.98232 14.0693 3.51514 14.0693H10.6089C11.1433 14.0693 11.5823 13.6506 11.6073 13.1162L11.9933 4.94434H12.937C13.0058 4.94434 13.062 4.88809 13.062 4.81934V4.31934C13.062 4.04277 12.8386 3.81934 12.562 3.81934ZM10.4886 12.9443H3.63545L3.25732 4.94434H10.8667L10.4886 12.9443Z",
		fill: "#FF4D4F"
	})]
});
const ForwardRef = forwardRef(SvgTrashOutlined);
export { ForwardRef as ReactComponent };
